/** A control label long enough to warrant a wider action button. */
export const WIDE_LABEL_THRESHOLD = 40;

export const isWideLabel = (label: string | undefined): boolean => {
  return (label?.length ?? 0) > WIDE_LABEL_THRESHOLD;
};
